import { all, takeLatest } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import { entityJurisdictionInfoRequest } from '@store/entityJurisdictions/entityJurisdictionsDetail/entityJurisdictionInfo/entityJurisdictionInfo.reducer';
import { entityJurisdictionsListRequest } from '@store/entityJurisdictions/entityJurisdictionsList/entityJurisdictionsList.reducer';

import { handleFetchEntityJurisdictionInfoRequest } from './handleFetchEntityJurisdictionInfoRequest';

export default all([
  takeLatest(entityJurisdictionInfoRequest.type, handleFetchEntityJurisdictionInfoRequest),
  takeLatest(entityJurisdictionsListRequest.type, handleRequest),
]);
